import { render, staticRenderFns } from "./AuthMain.vue?vue&type=template&id=96936696"
import script from "./AuthMain.vue?vue&type=script&lang=js"
export * from "./AuthMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports